import React from 'react'
import { connect } from 'react-redux'
import {MatomoContext} from '@streamr/matomo-tracker-react';

import InternLoginOverlay from './intern/InternLoginOverlay'
import InternModusOriginDestOverlay from './intern/InternModusOriginDestOverlay'
import InternModusColorOverlay from './intern/InternModusColorOverlay'
import InternHeaderPanel from './intern/InternHeaderPanel'
import InternLeftPanel from './intern/InternLeftPanel'

import HeaderPanel from './panel/HeaderPanel'
import LeftPanel from './panel/LeftPanel'
import DetailPanel from './panel/DetailPanel'
import StartOverlay from './panel/StartOverlay'
import GlobalLoader from './GlobalLoader'
import MapBox from './map/MapBox';
import NotFoundRedirect from './NotFoundRedirect'
import FlyingFocus from './FlyingFocus'
import FullOverlayAutocompleteNoResult from './panel/FullOverlayAutocompleteNoResult'
import {build_router_infos} from '../utils/Router'
import JSONDataContext from '../context'

import {
    toggle_panel_detail_open, 
	toggle_panel_start_overlay_is_open,
	loader_global_hide,
	set_json_loaded
} from '../actions'

/* 
	Wraps Page and combines the two contexts and makes
	them available through props. Faster solution
	and less code than merge the contexts
*/
const PageWithContext = () => {
	return (
		<JSONDataContext.Consumer>
			{json => (
				<MatomoContext.Consumer>
					{matomo_tracker => (
						<Page json={json} matomo_tracker={matomo_tracker} />
					)}
				</MatomoContext.Consumer>
			)}
		</JSONDataContext.Consumer>
  );
}

class Page extends React.Component { 
	
	constructor(props) {
		super(props);
		this.state = {
			a11y_class: '', // additional class for page, flying focus specific
			initial_tracking_done: false // make it possible to track the initial call (and not do it all over again)
		}
	}
	
	componentDidUpdate(prev_props) {
		const {
			panel_detail_open,
			panel_start_overlay_is_open,
			map_loaded,
			json_loaded,
			pathname
		} = this.props
		
		const router_infos = build_router_infos(pathname)
		
		if(map_loaded && json_loaded) {
			// @TODO: this is not needed for mobiles?
			if(!panel_detail_open && (router_infos.type === 'station' || router_infos.type === 'line' )) {
				this.props.toggle_panel_detail_open(true)
			}
			if(panel_detail_open && (router_infos.type === 'home' || router_infos.type === 'not_found')) {
				this.props.toggle_panel_detail_open(false)
			}
			
			// track page view
			if(this.props.matomo_tracker !== undefined && (pathname !== prev_props.pathname || !this.state.initial_tracking_done)) {
				this.props.matomo_tracker.trackPageView()
				if(!this.state.initial_tracking_done) {
					this.setState({
						initial_tracking_done: true
					})
				}
			}
		}
		
		// check if the context is given, and if json is not loaded
		if(this.props.json !== undefined && !json_loaded) {
			this.props.set_json_loaded()
			this.props.loader_global_hide()
		}

		if(router_infos.type !== 'home' && panel_start_overlay_is_open){
		    this.props.toggle_panel_start_overlay_is_open(false)
        }
	}
	
	set_a11y_class_state = (a11y_class) => {
		this.setState({
			a11y_class: a11y_class
		})
	}
	
	/*
		Check if the data exists, else redirect in render
	*/
	check_404 = (pathname) => {
	    const router_infos = build_router_infos(pathname);
	    const { type, from_slug, to_slug, line_slug } = router_infos;
	
	    // Fail-Fast: If the router already gave up, it's a 404
	    if (type === 'not_found') return true;
	
	    // Success-Fast: Home and Intern are valid by definition
	    if (type === 'home' || type === 'intern') return false;
	
	    // Destructure data for the remaining checks
	    const { all_stations, all_lines } = this.props.json.general;
	
	    // Handle Station logic
	    if (type === 'station') {
	        const from_exists = from_slug === undefined || all_stations.some(x => x.code === from_slug);
	        const to_exists = to_slug === undefined || all_stations.some(x => x.code === to_slug);
	
	        return !from_exists || !to_exists;
	    }
	
	    // Handle Line logic
	    if (type === 'line') {
	        return !all_lines.some(x => x.code === line_slug);
	    }
	
	    return false;
	};
	
	get_public_page_class = () => {
		/*
			TODO: ron check, not sure if this overlaps in some
			way with intern.
		*/
		const {
			a11y_class
		} = this.state
		
		const {
			loader_global_show_count,
			panel_detail_open,
			panel_detail_content_is_open,
			panel_left_open,
			panel_start_overlay_is_open,
			panel_full_overlay_is_open,
		} = this.props
					
		let page_class = a11y_class !== ''? `page ${a11y_class}`: 'page'
				
		if(loader_global_show_count > 0) {
			page_class += " global-loader-run"
		}
		if(panel_left_open) {
			page_class += " panel-left-open"
		}
		if(panel_detail_open) {
			page_class += " detail-open"
		}
		if(panel_detail_content_is_open){
			page_class += " detail-content-open"
		}
		if(panel_start_overlay_is_open) {
			page_class += " start-overlay-open"
		}
		if(panel_full_overlay_is_open) {
			page_class += " full-overlay-open"
		}
		
		return page_class
	}
	
	/*
		if the key of mapbox does not change,
		react will not unmount the component (Reconciliation algorithm)
	*/
	
	get_public_components = () => {
		return [
			<HeaderPanel key="header-panel" />,
			<MapBox key="mapbox-public" />,
			<LeftPanel key="left-panel" />,
			<StartOverlay key="start-overlay" />,
			<DetailPanel key="detail-panel" />,
			<FullOverlayAutocompleteNoResult key="full-overlay-autocomplete-no-result"/>,
		]
	}
	
	get_intern_components = () => {
		return [
			<InternHeaderPanel key="intern-header-panel" />,
			<MapBox key="mapbox" />,
			<InternLeftPanel key="intern-left-panel" />,
			<InternModusOriginDestOverlay key="intern-modus-origindest-overlay" />,
			<InternModusColorOverlay key="intern-modus-color-overlay" />,
		]
	}
	
	get_intern_page_class = () => {
		/*
			TODO: ron check, not sure if this overlaps in some
			way with public.
		*/
		const {
			a11y_class
		} = this.state
		
		const {
			loader_global_show_count,
			intern_panel_left_open
		} = this.props
		
		let page_class = a11y_class !== ''? `page ${a11y_class}`: 'page'
		if(loader_global_show_count > 0) {
			page_class += " global-loader-run"
		}
		if(intern_panel_left_open) {
			page_class += " panel-left-open"
		}
		
		return page_class
	}
	
	render = () => {

		const {
			pathname,
			is_authenticated,
			is_initial_config_request_done
		} = this.props
		
		const {
			a11y_class
		} = this.state

		const {
			json_loaded,
		} = this.props
		
		let page_class = ''
	
		let components = [
			<GlobalLoader key="globalloader" />,
		]
		
		const router_infos = build_router_infos(pathname);
	
		let show_public_components = router_infos.type === 'intern' ? false : true
		
		let is_404 = false
		
		if(json_loaded && is_initial_config_request_done) {
			is_404 = this.check_404(pathname)
			if(is_404) {
				components = [
					<NotFoundRedirect key="not-found-redirect"/>
				]
			} else {
				if(show_public_components) {
					page_class = this.get_public_page_class()
					
					components = [
						...components,
						...this.get_public_components(),
					]
				} else {
					if(is_authenticated) { // show intern
						page_class = this.get_intern_page_class()
						components = [
							...components,
							...this.get_intern_components()
						]
					} else { // show public with login overlay
						// not sure if page class is a mix of public/intern
						page_class = this.get_public_page_class()
						components = [
							...components,
							...this.get_public_components(),
							<InternLoginOverlay key="intern-login-overlay" />
						]
					}
				}
			}
		}
		
		return (
			<div id="page-container" className={page_class}>
				{components}
				<div style={{position: 'absolute', top: '50px', width: '8px', height: '100vh', left: 0, zIndex: 701}}></div>
				<div style={{position: 'absolute', top: '50px', width: '8px', height: '100vh', right: 0, zIndex: 702}}></div>
				<FlyingFocus set_a11y_class_state={this.set_a11y_class_state} a11y_class={a11y_class} />
			</div>
		)
	}
}

const map_state_to_props = state => {
	return {
		loader_global_show_count: state.general.ui.loader_global_show_count,
		panel_detail_open: state.general.panels.panel_detail_open,
        panel_detail_content_is_open: state.general.panels.panel_detail_content_is_open,
        panel_start_overlay_is_open: state.general.panels.panel_start_overlay_is_open,
        panel_full_overlay_is_open: state.general.panels.panel_full_overlay_is_open,
		panel_left_open: state.general.panels.panel_left_open,
		map_loaded: state.general.data.map_loaded,
		json_loaded: state.general.data.json_loaded,
		pathname: state.router.location.pathname,
		is_initial_config_request_done: state.general.intern.is_initial_config_request_done,
		is_authenticated: state.general.intern.is_authenticated,
		intern_panel_left_open: state.general.intern_ui.panel_left_open,
	}
}

const map_dispatch_to_props = dispatch => {
	return {
		toggle_panel_detail_open: panel_detail_open => {
			dispatch(toggle_panel_detail_open(panel_detail_open));
		},
		toggle_panel_start_overlay_is_open: panel_start_overlay_is_open => {
			dispatch(toggle_panel_start_overlay_is_open(panel_start_overlay_is_open));
		},
		loader_global_hide: () => {
			dispatch(loader_global_hide())
		},
		set_json_loaded: () => {
			dispatch(set_json_loaded())
		},
	}
}

Page = connect(
	map_state_to_props,
	map_dispatch_to_props
)(Page)

export default PageWithContext